/**
 * Mock implementation of Node.js http module for browser environment
 */

import { EventEmitter } from './events.js';

export class Server extends EventEmitter {
  constructor() {
    super();
  }
  
  listen(port: number, hostname?: string, callback?: () => void) {
    console.log(`[MockHTTP] Server listening on ${hostname || 'localhost'}:${port}`);
    if (callback) {
      callback();
    }
    return this;
  }
  
  close(callback?: () => void) {
    console.log(`[MockHTTP] Server closed`);
    if (callback) {
      callback();
    }
    return this;
  }
}

export const createServer = (requestListener?: (req: any, res: any) => void): Server => {
  console.log(`[MockHTTP] createServer`);
  const server = new Server();
  if (requestListener) {
    server.on('request', requestListener);
  }
  return server;
};

export const STATUS_CODES: Record<number, string> = {
  200: 'OK',
  201: 'Created',
  202: 'Accepted',
  204: 'No Content',
  301: 'Moved Permanently',
  302: 'Found',
  304: 'Not Modified',
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  500: 'Internal Server Error',
};

export const get = (...args: any[]): { end: () => void } => {
  const callback = typeof args[args.length - 1] === 'function' ? args[args.length - 1] : null;
  if (callback) {
    setTimeout(() => {
      const res = new EventEmitter();
      (res as any).statusCode = 200;
      (res as any).setEncoding = () => {};
      (res as any).on = res.on.bind(res);
      (res as any).headers = {};
      callback(res);
    }, 0);
  }
  return { end: () => {} };
};

// Export all http functions and classes
export default {
  createServer,
  Server,
  STATUS_CODES,
  get,
};
